module.exports = "<ciu-header></ciu-header>\r\n<ciu-container></ciu-container>\r\n<ciu-footer></ciu-footer>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/majli/reposales365/sale365/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main